import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

/**
 * Bottom-of-page related-links module. Renders 3-4 curated links to
 * topically-adjacent pages so both crawlers and visitors have a clear next
 * step. Drop it in above <CTAStrip /> on any page.
 *
 *   <RelatedLinks
 *     eyebrow="Related reading"
 *     title="Continue exploring"
 *     links={[
 *       { to: "/foo", label: "Foo — short context" },
 *       { to: "/bar", label: "Bar — short context" },
 *     ]}
 *   />
 */
export default function RelatedLinks({
  eyebrow = "Related",
  title = "Continue exploring",
  links = [],
}) {
  if (!links.length) return null;
  return (
    <section
      className="section border-t border-line"
      data-testid="related-links"
    >
      <div className="container-x grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <p className="eyebrow mb-4">{eyebrow}</p>
          <h2 className="h2">{title}</h2>
        </div>
        <div className="lg:col-span-8 border border-line bg-white">
          <div className="divide-y divide-line">
            {links.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                className="flex items-center justify-between gap-6 px-6 py-5 text-sm font-medium text-ink hover:text-brand hover:bg-surface-subtle transition-colors"
                data-testid={`related-link-${l.to.replace(/\//g, "")}`}
              >
                <span>{l.label}</span>
                <ArrowRight className="h-4 w-4 shrink-0" />
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
